import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var TenByTenExhibitsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M4 2a1 1 0 00-1 1v4a1 1 0 001 1h16a1 1 0 001-1V3a1 1 0 00-1-1H4zm11 2h-2v2h2V4zm2 0v2h2V4h-2zm-6 0v2H9V4h2zM7 4H5v2h2V4zM4 11h8a1 1 0 011 1v9a1 1 0 01-1 1H4a1 1 0 01-1-1v-9a1 1 0 011-1zm1 7h2v2H5v-2zm4 2v-2h2v2H9zm-2-5v-2H5v2h2zm2 0h2v-2H9v2zM20 11a1 1 0 011 1v9a1 1 0 01-1 1h-4a1 1 0 01-1-1v-9a1 1 0 011-1h4zm-1 4v-2h-2v2h2zm0 3v2h-2v-2h2z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
TenByTenExhibitsIcon.isCarinaIcon = true;
export default TenByTenExhibitsIcon;
